<template>
  <div :class="getCss('game-list')" :style="styles.base">
    <!-- 第一名 -->
    <div v-if="calculateGameList[0]" :class="getCss('game-item-one')"
        @click="jumpLinkHandler(calculateGameList[0])"
        :style="oneStyle"
        >
        <div :class="getCss('game-item-img')" :style="{ backgroundImage: `url(${getIcon(0)})` }">
          {{ $isInEditor && !isInPreview ? 1 : '' }}
        </div>
    </div>
    <!-- 第二名、第三名 -->
    <div :class="getCss('game-item-two-three')" :style="twoAndThreeStyle">
      <div v-if="calculateGameList[1]" :class="getCss('two-and-three')"
        @click="jumpLinkHandler(calculateGameList[1])"
        >
        <div :class="getCss('game-item-img')" :style="{ backgroundImage: `url(${getIcon(1)})` }">
          {{ $isInEditor && !isInPreview ? 2 : '' }}
        </div>
      </div>
      <div v-if="calculateGameList[2]" :class="getCss('two-and-three')"
        @click="jumpLinkHandler(calculateGameList[2])"
        >
        <div :class="getCss('game-item-img')" :style="{ backgroundImage: `url(${getIcon(2)})` }">
          {{ $isInEditor && !isInPreview ? 3 : '' }}
        </div>
      </div>
    </div>
    <div
      v-if="useScrollBar"
      :class="getCss('game-outer-scroll')"
      :style="widthOrHeightComputed"
    >
      <div :style="leftBtnStyle" @click="changeIndex(0)"></div>
      <template v-for="(item, index) in calculateGameList">
        <div :class="getCss('game-item')"
          v-if="index >= gameListStart && index < gameListEnd"
          :key="index"
          @click="jumpLinkHandler(item)"
          >
          <div
            :class="getCss('game-item-img')" :style="{ backgroundImage: `url(${item.gameIcon})` }"
          >
            {{ $isInEditor && !isInPreview ? `${index + 1}` : '' }}
          </div>
        </div>
      </template>
      <div :style="rightBtnStyle" @click="changeIndex(1)"></div>
    </div>
    <div
      v-else
      :class="getCss('game-outer')"
      :style="widthOrHeightComputed"
    >
      <template v-for="(item, index) in calculateGameList">
        <div :class="getCss('game-item')"
          v-if="index > 2"
          :key="index"
          @click="jumpLinkHandler(item)"
          >
          <div :class="getCss('game-item-img')" :style="{ backgroundImage: `url(${item.gameIcon})` }">
            {{ $isInEditor && !isInPreview ? `${index + 1}` : '' }}
            <!-- {{ `${index + 1}` }} -->
          </div>
        </div>
      </template>
      <!-- 占位用 -->
      <div :class="getCss('game-item-take')" v-for="item in computedLastPartyNumber" :key ="item">
      </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
const BB_VIA_LIST = [
  'qqfcmzs',
  'zhcfm',
  'cfzs',
  'zhcfhd',
  'dnfzs',
  'nzzs',
  'qqfcpczs',
  'xwxlt',
  'xwsdzs',
  'tdzs',
  'txyxsq',
  'zs',
];
export default {
  name: 'CPublicGameList',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-game-list-',
      calculateGameList: [],
      gameListStart: 3,
      gameListEnd: 9,
      useScrollBar: this.configurationData?.useScrollBar || false,
      openList: {}, // 游戏跳转开放状态配置
    };
  },
  computed: {
    getIcon() {
      return index => this.calculateGameList?.[index]?.gameIcon || '';
    },
    widthOrHeightComputed() {
      return {
        '--borderColor': this.configurationData.borderColor || '#ccc', // 边框颜色
        '--borderWidth': `${this.configurationData.borderWidth || '31.5'}%`, // 边框宽度
        '--borderHeight': `${this.configurationData.borderHeight || '1.2'}rem`, // 边框高度
        '--bottomHeight': `${this.configurationData.bottomHeight || '0.2'}rem`, // 底部间距
        '--iconSize': `${this.configurationData.iconSize || '90'}%`, // 游戏图片大小
      };
    },
    computedLastPartyNumber() {
      const { gameList } = this.configurationData;
      const lastPartyNumber = parseInt(100 / this.configurationData.borderWidth, 10);
      const number = gameList.length % lastPartyNumber;
      return lastPartyNumber - number || 0;
    },
    // 第一名样式
    oneStyle() {
      let { width: containerWidth } = this.styles.base;
      if (containerWidth.indexOf('rem') > -1) {
        containerWidth = parseFloat(containerWidth.substring(0, containerWidth.length - 3), 3);
        containerWidth = containerWidth * this.multiplier;
      } else if (containerWidth.indexOf('px') > -1) {
        containerWidth = parseFloat(containerWidth.substring(0, containerWidth.length - 2), 3);
      }
      return {
        '--borderColor': this.configurationData.borderColor || '#ccc', // 边框颜色
        '--one-width': `${containerWidth / 2}px`,
        '--one-height': `${this.configurationData.oneHeight || '1.5'}rem`,
        '--iconSize': `${this.configurationData.iconSize || '90'}%`, // 游戏图片大小
        '--bottomHeight': `${this.configurationData.bottomHeight || '0.2'}rem`, // 底部间距
      };
    },
    // 第二名、第三名样式
    twoAndThreeStyle() {
      let { width: containerWidth } = this.styles.base;
      if (containerWidth.indexOf('rem') > -1) {
        containerWidth = parseFloat(containerWidth.substring(0, containerWidth.length - 3), 3);
        containerWidth = containerWidth * this.multiplier;
      } else if (containerWidth.indexOf('px') > -1) {
        containerWidth = parseFloat(containerWidth.substring(0, containerWidth.length - 2), 3);
      }
      return {
        '--borderColor': this.configurationData.borderColor || '#ccc', // 边框颜色
        '--two-three-width': `${containerWidth / 2.1}px`,
        '--two-three-height': `${this.configurationData.twoAndThreeHeight || '1.5'}rem`,
        '--iconSize': `${this.configurationData.iconSize || '90'}%`, // 游戏图片大小
        '--bottomHeight': `${this.configurationData.bottomHeight || '0.2'}rem`, // 底部间距
      };
    },
    // 左按钮样式
    leftBtnStyle() {
      return {
        backgroundImage: `url(${this.configurationData?.leftBtnImg || 'https://act.supercore.qq.com/activity/supercore/15324/2ba3a5824f832604570f1c3ab9561d95.png'})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: '0.39rem',
        height: '0.57rem',
        left: this.configurationData?.leftBtnLeft || '-0.39rem',
        top: `${this.configurationData?.leftBtnTop}rem` || '3.2rem',
        position: 'absolute',
      };
    },
    // 右按钮样式
    rightBtnStyle() {
      return {
        backgroundImage: `url(${this.configurationData?.rightBtnImg || 'https://act.supercore.qq.com/activity/supercore/15324/932bda8568e348f845b0db812720a8f5.png'})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: '0.39rem',
        height: '0.57rem',
        right: this.configurationData?.rightBtnRight || '-0.39rem',
        top: `${this.configurationData?.rightBtnTop}rem` || '3.2rem',
        position: 'absolute',
      };
    },
    multiplier() {
      if (this.$isInEditor) {
        return 100;
      }
      const fontSize = this.rootFontSize;
      return fontSize ? parseFloat(fontSize.substring(0, fontSize.length - 2), 3) : 50;
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      console.log('configurationData=c-public-game-list: 游戏列表跳转组件', this.configurationData);
      await this.initCalculateGameList();
      this.$onLogined(() => {
        this.getGameList();
        this.getGameOpenInfo(); // 获取游戏开放信息
      });
    },
    // 初始化分渠道投放常玩游戏列表
    initCalculateGameList() {
      console.log('calculateGameList', this.calculateGameList);
      const via = common.tool.getQueryparams('via') || '';

      // 帮帮渠道
      BB_VIA_LIST.forEach((v) => {
        if (via.startsWith(v)) {
          this.calculateGameList = this.queryCurrentChannel('bb');
        }
      });

      // 闪现渠道
      if (via.startsWith('spark')) {
        this.calculateGameList = this.queryCurrentChannel('spark');
      }
      // 知己渠道
      if (via.startsWith('gbot')) {
        this.calculateGameList = this.queryCurrentChannel('gbot');
      }
      // 心悦渠道
      if (via.startsWith('vip')) {
        this.calculateGameList = this.queryCurrentChannel('vip');
      }
      // 超核渠道
      if (via.startsWith('svip')) {
        this.calculateGameList = this.queryCurrentChannel('svip');
      }
      // 商业化业务其他渠道标识
      if (via.startsWith('upother')) {
        this.calculateGameList = this.queryCurrentChannel('upother');
      }
      console.log('calculateGameList==', this.calculateGameList);
    },
    // 查询当前渠道
    queryCurrentChannel(channelName) {
      const inChannelGameList = [];
      this.configurationData?.gameList?.forEach((item) => {
        item?.deliveryChannelString?.split('/')?.forEach((v) => {
          if (v === channelName) {
            inChannelGameList.push(item);
          }
        });
      });
      console.log('inChannelGameList==', channelName, inChannelGameList);
      return inChannelGameList;
    },
    // 切换展示游戏
    changeIndex(type) {
      if (type === 0) {
        if ((this.gameListStart - 6) < 3) {
          return;
        }
        this.gameListStart -= 6;
        this.gameListEnd -= 6;
        return;
      }
      if ((this.gameListStart + 6) > this.calculateGameList.length) {
        return;
      }
      this.gameListStart += 6;
      this.gameListEnd += 6;
      return;
    },
    // 获取游戏列表
    async getGameList() {
      if (this.configurationData.gameListFlowId > 0) {
        const res = await this.flowRequest({
          flowId: this.configurationData.gameListFlowId,
        });
        const { data } = res;
        if (res.ret !== 0) {
          return;
        }
        // 将接口返回的常玩游戏列表和配置的游戏列表做对比，抽取到数据顶层
        const currentGameList = [];
        data?.data?.forEach((i) => {
          const flag = this.calculateGameList.findIndex((v) => {
            if (String(v.gameGid) === String(i.gid)) {
              currentGameList.push(v);
            }
            return String(v.gameGid) === String(i.gid);
          });
          // 返回的常玩游戏在配置内
          if (flag !== -1) {
            this.calculateGameList.splice(flag, 1);
          }
        });
        // 提取常玩游戏 放置到数据顶层
        this.calculateGameList = [...currentGameList, ...this.calculateGameList];
        console.log('testing_res=', currentGameList, this.calculateGameList);
      }
    },
    // 获取游戏开放信息
    async getGameOpenInfo() {
      if (this.configurationData.getGameOpenInfoFlowID > 0) {
        const res = await this.flowRequest({
          flowId: this.configurationData.getGameOpenInfoFlowID,
        });
        const { data } = res;
        if (res.ret !== 0) {
          return;
        }
        this.openList = JSON.parse(data.valStr);
      }
    },
    async jumpLinkHandler(item) {
      // 判断是否登录 如果配置了获取开放状态流程,并且未登录,
      if (!this.isLogin && !!this.configurationData.getGameOpenInfoFlowID) {
        baseComponents.userLoginComponent.login();
        return;
      }
      let url = item.gameJumpLink;
      if (!url) {
        return this.alert(this.configurationData?.emptyDialogText || '活动即将上线，敬请期待~');
      }
      // 如果配置了获取开放状态流程,并且未开放,弹提示
      if (!!this.configurationData.getGameOpenInfoFlowID) {
        if (!this.openList[item.gameGid]) {
          this.alert(this.configurationData?.notOpenDialogText || '活动即将上线，敬请期待~');
          return;
        }
      }

      // 截取一级域名
      const domain = url.split('//')[1]?.split('/')[0];
      await new Promise((resolve) => {
        try {
          this.$miloCore?.loginStatus?.syncToQQ(domain, {
            appid: common.tool.getCookie('appid') || '',
            openid: common.tool.getCookie('openid') || '',
            access_token: common.tool.getCookie('access_token') || '',
            acctype: common.tool.getCookie('acctype') || '',
          }, () => {
            console.log('sync login status');
            resolve();
          });
        } catch (err) {
          console.log('syncToQQ==', err);
        }
      });
      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      url = common.tool.passThroughUrlParam(url, ['via', 'trace_id', 'via_source', 'inviteCode', 'singleGame', 'commander_id']);
      window.location.href = url;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
